import { useMutation, useQueryClient } from 'react-query';
import type { PaymentMethodViewDto } from '@subscriptions/application/dtos';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';

/**
 * Hook for generating the SPEI CLABE reference for a subscription block.
 *
 * Resolves with the full attached payment method (CLABE in `providerPublicId`)
 * so the SPEI confirmation screen can render directly. On success, invalidates
 * the cached `['subscriptions', 'blocks', 'detail', blockUuid]` query (the key
 * used by `useSubscriptionBlock`) so downstream views refetch.
 *
 * @returns React Query mutation result
 */
export const useGenerateBlockReference = () => {
  const queryClient = useQueryClient();
  const { generateReferenceSubscriptionBlock } = getSubscriptionBlockUseCases();

  return useMutation<PaymentMethodViewDto, Error, string>(
    (blockUuid) => generateReferenceSubscriptionBlock.execute(blockUuid),
    {
      onSuccess: (_, blockUuid) => {
        queryClient.invalidateQueries(['subscriptions', 'blocks', 'detail', blockUuid]);
      },
    },
  );
};
